import { SegmentOrDomainCellWithoutDomainSign } from "app/components/React/Table/cells/SegmentOrDomainCell";
import { DefaultCellHeader, DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import { ChangePercentage, DefaultCellRightAlign } from "app/components/React/Table/cells";
import { translate } from "app/filters/i18nFilter";
import {
    CHANGE_ATTRIBUTE,
    POP_CHANGE_ATTRIBUTE,
} from "app/pages/industry-analysis/players/rising-and-declining-players/const";

export const getColumnsConfig = (isPeriodOverPeriod = false, isYearOverYear = false) => {
    const columns = [
        {
            field: "Domain",
            displayName: translate("industry.leaders.top.players.domain.column"),
            type: "string",
            format: "None",
            sortable: false,
            cellComponent: SegmentOrDomainCellWithoutDomainSign,
            headerComponent: DefaultCellHeader,
            showTotalCount: false,
            isResizable: false,
            width: "50%",
            headerCellClass: "industry-leaders-players-widget-header-cell",
            cellClass: "industry-leaders-players-widget-row-cell",
        },
        {
            field: "LastMonthUniqueUsers",
            displayName: translate("industry.leaders.top.players.unique.users.column"),
            tooltip: translate("market.research.players.unique.users.tooltip"),
            type: "double",
            format: "minVisitsAbbr",
            sortable: false,
            cellComponent: DefaultCellRightAlign,
            headerComponent: DefaultCellHeaderRightAlign,
            showTotalCount: false,
            width: "25%",
            isResizable: false,
            headerCellClass: "industry-leaders-players-widget-header-cell",
            cellClass: "industry-leaders-players-widget-row-cell",
        },
        {
            field: isPeriodOverPeriod ? POP_CHANGE_ATTRIBUTE : CHANGE_ATTRIBUTE,
            displayName: translate(
                isYearOverYear
                    ? "market.research.players.rising.declining.year.change"
                    : "market.research.players.rising.declining.period.change",
            ),
            tooltip: translate(
                isYearOverYear
                    ? "market.research.players.rising.declining.year.change.tooltip"
                    : "market.research.players.rising.declining.period.change.tooltip",
            ),
            type: "double",
            format: "percentagesign",
            sortable: false,
            cellComponent: ChangePercentage,
            headerComponent: DefaultCellHeaderRightAlign,
            showTotalCount: false,
            width: "25%",
            isResizable: false,
            headerCellClass: "industry-leaders-players-widget-header-cell",
            cellClass: "industry-leaders-players-widget-row-cell",
            tooltipAutoPlacement: false,
        },
    ];

    return columns.map((col) => {
        return {
            ...col,
            visible: true,
            isSorted: false,
            sortDirection: "desc",
        };
    });
};
